













































































































































































import INoticeOfLoss from '@/store/models/INoticeOfLoss';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import INoticeOfLossDetail from '@/store/models/INoticeOfLossDetail';
import moment from 'moment';
import OutboundsNoticeOfLossDetailSelector from '@/components/selectors/NoticeOfLoss/OutboundsNoticeOfLossDetailSelector.vue';
import IOutboundDeliveryNotesDetail from '@/store/models/IOutboundDeliveryNotesDetail';
@Component({
    components: {
        Snackbar,
        OutboundsNoticeOfLossDetailSelector
    }
})
export default class OutboundsDeliveryNoteNoticeOfLossSelector extends Vue {
    searchNoticeOfLoss: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'date';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Warehouse',
            align: 'start',
            value: 'warehouseName'
        },
        { text: 'Date', value: 'date' },
        { text: 'Description', value: 'description' },
        { text: 'Actions', value: 'actions' }
    ];
    editedIndex : number = -1;
    editedItem : INoticeOfLoss = {
        id: "",
        idDeliveryNote: "",
        idWarehouse: "",
        warehouseName: "",
        date: new Date(),
        description: ""
    }
    defaultItem : INoticeOfLoss = {
        id: "",
        idDeliveryNote: "",
        idWarehouse: "",
        warehouseName: "",
        date: new Date(),
        description: ""
    }

    @Prop({ type: Array, required: true })
    NoticeOfLossList !: INoticeOfLoss[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ required: true })
    WarehouseName !: string;
    @Prop({ type: Array, required: true })
    NoticeOfLossDetailList !: INoticeOfLossDetail;
    @Prop({ type: Array, required: true })
    OutboundDeliveryNotesDetailList !: IOutboundDeliveryNotesDetail[];
    @Prop()
    Loading !: boolean;
    @Prop()
    value !: INoticeOfLoss;

    selectedNoticeOfLoss : INoticeOfLoss[] = [];
    selectedNoticeOfLossDetail : INoticeOfLossDetail[] = [];
    menu2: boolean = false;
    date: string = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);

    get DateFormatted() {
        return this.formatDate(this.date);
    }

    formatDate (date: string) {
        if (!date) return null;

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }

    parseDate (date: string) {
        if (!date) return null;

        const [month, day, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    get formTitle() { return this.editedIndex === -1 ? 'New Notice of loss' : 'Edit Notice of loss'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    @Watch('value')
    updateSelection(newValue : INoticeOfLoss | null) {
        if (!newValue || Object.keys(newValue).length === 0) {
            this.selectedNoticeOfLoss = [];
        } else {
            this.selectedNoticeOfLoss = [newValue];
            this.$emit('onChangeSelectedNoticeOfLoss', this.selectedNoticeOfLoss);
        }
    }
    
    getOutboundDeliveryNotesDetails() {
        this.$emit('getOutboundDeliveryNotesDetails');
    }

    onChangeNoticeOfLossDetail(noticeOfLossDetail : INoticeOfLossDetail) {
        this.$emit('onChangeNoticeOfLossDetail', noticeOfLossDetail);
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    ResetNoticeOfLoss() {
        this.selectedNoticeOfLoss = [];
        this.selectedNoticeOfLossDetail = [];
        this.$emit('resetNoticeOfLoss');
    }

    editNoticeOfLoss (item: INoticeOfLoss, dbox = true) {
        this.editedIndex = this.NoticeOfLossList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.date = moment(new Date(item.date)).format('YYYY-MM-DD');
        this.dialog = true;
    }

    saveNoticeOfLoss () {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            this.editedItem.warehouseName = this.WarehouseName;
            this.editedItem.date = new Date(this.date);
            if (this.editedIndex > -1 || this.selectedNoticeOfLoss[0]) {
                let index = this.NoticeOfLossList.findIndex(o => o.id === this.editedItem.id);
                Object.assign(this.NoticeOfLossList[index], this.editedItem);
                this.$emit('editNoticeOfLoss', this.editedItem);
                this.close();
            } else {
                this.$emit('saveNoticeOfLoss', this.editedItem);
            }
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    saveNoticeOfLossDetail(noticeOfLossDetails: INoticeOfLossDetail[]) {
        if (noticeOfLossDetails.length > 0) {
            noticeOfLossDetails.forEach(element => {
                element.idNoticeOfLoss = this.selectedNoticeOfLoss[0].id;
            });
            this.$emit('saveNoticeOfLossDetail', noticeOfLossDetails);
        }
    }

    deleteNoticeOfLoss (noticeOfLoss: INoticeOfLoss) {
        this.$emit('deleteNoticeOfLoss', noticeOfLoss);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }
    
    select(item : INoticeOfLoss) : void {
        let index : number = this.selectedNoticeOfLoss.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedNoticeOfLoss = [item];
            this.$emit('input', item);
        } else {
            let noticeOfLoss = this.selectedNoticeOfLoss.find(w => w.id === item.id);
            if (!noticeOfLoss) {
                this.selectedNoticeOfLoss = [];
                this.$emit('input', null);
            }
        }
    }

    editNoticeOfLossDetail(noticeOfLossDetail: INoticeOfLossDetail) {
        this.$emit('editNoticeOfLossDetail', noticeOfLossDetail);
    }
  
    deleteNoticeOfLossDetail(noticeOfLossDetail: INoticeOfLossDetail) {
        this.$emit('deleteNoticeOfLossDetail', noticeOfLossDetail);
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
